import { formatDate } from '@/utils/Formatters/formatDate';

const receiveFastCheckoutProduct = (rawData) => {
  const { data } = rawData.data;

  return {
    error: false,
    id: data.product_id,
    name: data.product_name,
    cycles: data.cycles,
    discount: {
      value: data.discount.totalValue,
      type: data.discount.type,
      percentage: data.discount.percentage,
    },
    vat: data.vat.length > 0 ? data.vat.filter(vat => vat.name !== null) : [],
    totalValue: data.total_value,
    price: data.price,
    priceWithVat: data.price_with_vat,
    renewalDate: formatDate(data.renewal_date),
    paymentMethods: data.payment_methods,
    installments: data.installments,
  };
};
const assembly = {
  receiveFastCheckoutProduct,
};

export default assembly;
